import {BaseFragment, BaseFragmentProps} from "../../shared/BaseFragment";
import React from "react";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {nightGray} from "../../shared/colors";
import {PAGE_FRAGMENT_WIDTH} from "../../shared/dimens";

export type ViewAvatarFragmentProps = BaseFragmentProps&{
  imageUrl: string,
}

export class ViewAvatarFragment extends BaseFragment<ViewAvatarFragmentProps> {

  protected renderContainerContent(): React.ReactElement | null {
    return <StyledBoxColumn style={{flexGrow: 1, justifyContent:"center", alignItems:"center", background:nightGray}}>
      <img src={this.props.imageUrl} style={{width:"100%", aspectRatio: 1, maxWidth: PAGE_FRAGMENT_WIDTH}}/>
    </StyledBoxColumn>
  }
}